<template>
    <b-modal size="lg" ref="createNewItemModal" hide-footer :title="$t(`createpositionmodal.title`)">
        <b-container>
            <b-row>
                <b-col>
                    <b-form-group :label="$t(`questionnaire.answer_text`)" label-for="answer_text">
                        <b-form-input id="answer_text" type="text" :state="!$v.currentItem.answer_text.$error ? null : false" v-model="currentItem.answer_text" style="background-color: #fdfdfd"></b-form-input>
                    </b-form-group>
                </b-col>
                <b-col>
                    <b-form-group :label="$t(`questionnaire.answer_score`)" label-for="answer_score">
                        <b-form-input id="answer_score" type="text" v-model="currentItem.answer_score" style="background-color: #fdfdfd"></b-form-input>
                    </b-form-group>
                </b-col>
                <b-col>
                    <b-form-group :label="$t(`questionnaire.conditional_question_id`)" label-for="conditional_question_id">
                        <b-form-input id="conditional_question_id" type="text" v-model="currentItem.conditional_question_id" style="background-color: #fdfdfd"></b-form-input>
                    </b-form-group>
                </b-col>
            </b-row>
        </b-container>
        <b-button class="mt-3" variant="primary" block @click="createItem">{{ $t("createpositionmodal.button_safe") }}</b-button>
    </b-modal>
</template>
    <script>
    import QuestionnaireService from '../../../../../services/QuestionnaireService';
    import { helpers, required } from 'vuelidate/lib/validators';
    export default {
        name: 'answeroption-modal',
        props: ['savedCallback'],
        data() {
            return {
                currentItemEditMode: false,
                currentItem: {},
            }
        },
        validations: {
            currentItem: {
                answer_text:   {required},
            }
        },
        methods: {
            enterEditMode() {
                this.currentItemEditMode = true;
            },
            leaveEditMode() {
                this.currentItemEditMode = false;
            },
            showModal() {
                this.$v.$reset();
                this.currentItemEditMode = false;
                this.$refs.createNewItemModal.show();
            },
            hideModal() {
                this.$refs.createNewItemModal.hide();
                this.currentItem = {};
                this.$v.$reset();
            },
            setItem(questionId, Item) {
                this.questionId = questionId;
                this.currentItem = Item;
            },
            createItem() {
                this.$v.$touch();

                if(this.$v.$error) {
                    return;
                }

                this.$store.commit('loading/setLoading', true);

                if(!this.currentItemEditMode) {
                    QuestionnaireService.createAnsweroption(this.questionId, this.currentItem)
                        .then(response => {
                            this.$notify({
                                group: 'global',
                                title: this.$t("answeroptionmodal.notify_success_title"),
                                type: 'success',
                                text: this.$t("answeroptionmodal.notify_success_message")
                            });

                            this.$store.commit('loading/setLoading', false);

                            if(this.savedCallback){
                                this.savedCallback();
                            }

                            this.$refs.createNewItemModal.hide();
                            this.currentItem = {};
                        })
                        .catch(error => {
                            this.$store.commit('loading/setLoading', false);
                            this.$notify({
                                group: 'global',
                                title: this.$t("answeroptionmodal.notify_error_title"),
                                type: 'error',
                                text: error.message
                            });
                        });
                }else {
                    QuestionnaireService.updateAnsweroption(this.questionId, this.currentItem.id, this.currentItem)
                        .then(response => {
                            this.$notify({
                                    group: 'global',
                                title: this.$t("answeroptionmodal.notify_correction_title"),
                                    type: 'success',
                                text: this.$t("answeroptionmodal.notify_correction_message")
                                });

                            if(this.savedCallback){
                                this.savedCallback();
                            }

                            this.$refs.createNewItemModal.hide();
                            this.currentItem = {};
                        })
                        .catch(error => {
                            this.$store.commit('loading/setLoading', false);
                            this.$notify({
                                group: 'global',
                                title: this.$t("answeroptionmodal.notify_correction_error"),
                                type: 'error',
                                text: error.message
                            });
                        });
                }
            }
        }
    }
    </script>
